import React, { useState } from "react"
import * as classNames from "./ArticleCardVerticalBlock.module.scss"
import Button from "../../../common/blocks/button/Button"
import Card from "../../../common/blocks/card/Card"
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from "gatsby-plugin-modal-routing-3"

// Import Swiper styles
import "swiper/css"
import "swiper/css/pagination"
import { formatDate } from "../../../../../utils/formatDate"
import { tagUrl } from "../../../../../utils/routeLib"
import Icon from "../../../common/blocks/icon/Icon"
import Image from "../../../common/blocks/image/Image"

function ArticleCardVerticalBlock({ url, articles }) {
  const tags = articles?.attributes.tags.data
  const [displayedTags, setDisplayedTags] = useState(tags.slice(0, 3))
  const [showAllTags, setShowAllTags] = useState(tags.length <= 3)

  const handleShowAllTags = () => {
    setDisplayedTags(tags)
    setShowAllTags(true)
  }

  return (
    <Card
      className={`${classNames.ArticleCard}`}
      tag="article"
    >
      <div className={classNames.img}>
        <Link to={url}>
          <Image
            dataSizesPreset={"article"}
            imgSrc={articles?.attributes.image?.data?.attributes.url}
            imgAlt={articles?.attributes.image?.data?.attributes.alternativeText}
            imgWidth={articles?.attributes.image?.data?.attributes.width}
            imgHeight={articles?.attributes.image?.data?.attributes.height}
            formats={articles?.attributes.image?.data?.attributes?.formats}
            className={"centered"}
          />
        </Link>
        <div className={`${classNames.dateMobile}`}>
          <time>{formatDate(articles?.attributes.publishedAt)}</time>
        </div>
      </div>

      <div className={classNames.articleContent}>
        <Link
          to={url}
        >
          <h3>{articles?.attributes.title}</h3>
        </Link>
        <Link to={url}>
          <p>{articles?.attributes.Description}</p>
        </Link>
        <div className={classNames.tagsContainer}>
          <Swiper
            spaceBetween={10}
            slidesPerView={"auto"}
            className={classNames.tagsSwiper}
          >
            {articles?.attributes.tags.data.map((tag, i) => (
              <SwiperSlide className={classNames.tag}>
                <Button
                  key={tag}
                  aspect="tag"
                  size="small"
                  to={tagUrl(tag.attributes.autoRoute)}
                  color="secondary"
                >
                  #&thinsp;{tag.attributes.label}
                </Button>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={classNames.tagsMobile}>
            <div className={classNames.tagMobile}>
              {displayedTags.map((tag, i) => (
                <Button
                  key={tag}
                  aspect="tag"
                  to={tagUrl(tag.attributes.autoRoute)}
                  color="secondary"
                >
                  #{tag.attributes.label}
                </Button>
              ))}
            </div>
            {!showAllTags && (
              <div className={classNames.buttonTag}>
                <Button
                  aspect="unstyled"
                  color="primary"
                  onClick={handleShowAllTags}
                >
                  Voir plus
                  <Icon
                    icon="arrow"
                    color="var(--primary-color)"
                    width="20px"
                    height="20px"
                  />
                </Button>
              </div>
            )}
          </div>
          <div className={classNames.iconContainer}>
            <div className={`${classNames.date}`}>
              <time>{formatDate(articles?.attributes.publishedAt)}</time>
            </div>
            <div className={classNames.icon}>
              <Icon
                icon="calendar"
                color="var(--gris)"
                width="20px"
                height="20px"
              />
            </div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default ArticleCardVerticalBlock
